import { render, staticRenderFns } from "./liveMore.vue?vue&type=template&id=eb488bb6&scoped=true&"
import script from "./liveMore.vue?vue&type=script&lang=js&"
export * from "./liveMore.vue?vue&type=script&lang=js&"
import style0 from "./liveMore.vue?vue&type=style&index=0&id=eb488bb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb488bb6",
  null
  
)

export default component.exports